import axios from 'axios';
import { SWAGGER_ENDPOITS_WHITOUT_HKS } from './whiteList';
import { NAV_EXPERIENCE_PATH_SERVICE } from 'api/services/nav/paths';
import {
  transforFavorited,
  transformAudPreferences,
  transformCmsRequest,
  transformEpgEventsByGenre,
  transformMultiContentSearchRequest,
  transformMultiPbiRequest,
  transformPbiRequest,
  transformPurchaseNodeIdRequest,
  transformUserChannelsLiveSeen,
  transformUserRecommendationsRequest,
  transformWorkflowStart,
  transforSeen,
} from './utils/transformRequest';
import {
  transformCmsLevelResponse,
  transformLinealPredictiveResponse,
  transformMultiPbiResponse,
  transformNavExperienceResponse,
  transformPurchaseactiveresponse,
  transformResponseEPGEventsByGenre,
  transformUserChannelsSeenResponse,
  transformUserFavoriteAddResponse,
  transformUserFavoriteDeleteResponse,
  transformUserFavoriteResponse,
  transformUserRecommendations,
  transformUserSeenResponse,
} from './utils/transformResponse';
import { apiCall } from 'api';
import {
  getTokenUserAnonymous,
  setTokenUserAnonymous,
} from 'utils/user/anonymousLocalStoreUser';
import { store } from 'store.js';
import { getRegion } from 'utils/Region';
import { ANONYMOUS_USER } from '../../constants';

export const findInSwaggerWhiteList = (whiteList = [], url = '') => {
  const endpointFinded = whiteList.find(path => url.includes(path));
  return !!endpointFinded;
};

export const transformResponse = (response, url = '') => {
  transformCmsLevelResponse(response, url);
  transformNavExperienceResponse(response, url);
  transformLinealPredictiveResponse(response, url);
  transformPurchaseactiveresponse(response, url);
  transformUserFavoriteResponse(response, url);
  transformUserSeenResponse(response, url);
  transformMultiPbiResponse(response, url);
  transformUserFavoriteAddResponse(response, url);
  transformUserFavoriteDeleteResponse(response, url);
  transformUserChannelsSeenResponse(response, url);
  transformResponseEPGEventsByGenre(response, url);
  transformUserRecommendations(response, url);
};

const deleteHKSParam = request => {
  const { HKS, ...filteredParams } = request.params;
  request.params = filteredParams;
};

// eslint-disable-next-line no-unused-vars
export const transformRequest = (request, url = '', apiCall) => {
  transformCmsRequest(request, url);
  transformPurchaseNodeIdRequest(request, url);
  transformMultiPbiRequest(request, url);
  transformMultiContentSearchRequest(request, url);
  transformWorkflowStart(request, url);
  transformPbiRequest(request, url);
  transformAudPreferences(request, url);
  transforFavorited(request, url);
  transforSeen(request, url);
  transformUserChannelsLiveSeen(request, url);
  transformEpgEventsByGenre(request, url);
  transformUserRecommendationsRequest(request, url)

  if (findInSwaggerWhiteList(SWAGGER_ENDPOITS_WHITOUT_HKS, url)) {
    deleteHKSParam(request);
  }
};

function pathMatches(fullUrl, targetPath) {
  try {
    const urlObj = new URL(fullUrl);
    const urlPath = urlObj.pathname.replace(/\/+$/, '');
    const reqPath = targetPath.replace(/\/+$/, '');
    return urlPath === reqPath;
  } catch (e) {
    return false;
  }
}

export const cleanParamsByService = (url, params, rules) => {
  if (!params || typeof params !== 'object') return params;

  const ALWAYS_REMOVE = ['api_version'];
  const matchedRule = rules.find(rule => pathMatches(url, rule.path));

  const keysToRemove = new Set([
    ...ALWAYS_REMOVE.map(key => key.toLowerCase()),
    ...((matchedRule?.remove ?? []).map(key => key.toLowerCase())),
  ]);

  return Object.fromEntries(
    Object.entries(params).filter(
      ([key]) => !keysToRemove.has(key.toLowerCase())
    )
  );
};

export const buildRefreshTokenRequest = error => {
  const { baseURL, params, metadata } = error.config;
  const token = params?.user_token
    ? params?.user_token
    : metadata?.user_token ||
      apiCall?.defaults?.params?.user_token ||
      error?.response?.config?.headers['Authorization'] ||
      error?.response?.config?.headers['user-token'];

  const user_token = token?.replace(/^bearer\s+/i, '');

  const {
    authpn,
    authpt,
    device_category,
    device_model,
    device_type,
    device_name,
    device_manufacturer,
    device_id,
    device_so,
    format,
    region,
  } = params;

  return axios
    .get(`${baseURL}/services/user/v2/refresh_token`, {
      params: {
        authpn,
        authpt,
        device_category,
        device_model,
        device_type,
        device_name,
        device_manufacturer,
        device_id,
        device_so,
        format,
        region,
      },
      headers: {
        Authorization: `Bearer ${user_token}`,
      },
    })
    .catch(() => clearUserData());
};

export const persistUserToken = data => {
  const loggedUserData = JSON.parse(
    localStorage.getItem('loginInfo.logged_user_data'),
  );
  const getUserInfo = JSON.parse(localStorage.getItem('getUserInfo'));

  if (loggedUserData?.token) {
    loggedUserData.token = data;
    localStorage.setItem(
      'loginInfo.logged_user_data',
      JSON.stringify(loggedUserData),
    );
  }
  if (getUserInfo) {
    getUserInfo.token = data;
    localStorage.setItem('getUserInfo', JSON.stringify(getUserInfo));
  }

  if (
    !loggedUserData?.token &&
    !getUserInfo &&
    getTokenUserAnonymous !== null
  ) {
    // anonimo
    setTokenUserAnonymous(data);
  }
};

export const clearUserData = data => {
  store.dispatch({
    type: 'CLEARUSER',
    user: {
      userType: ANONYMOUS_USER,
      is_user_logged_in: 0,
    },
  });
  window.location.replace(`/${getRegion()}/login`);
  localStorage.clear();
};
